<template>
  <div :style="{'width': width}">
    <textarea :style="{height: height}" :id="id"></textarea>
  </div>
</template>

<script>
export default {
  name: "ckeditor",
  props: {
    value: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: '600px'
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  mounted: function() {
    const self = this;
    // 渲染编辑器
    self.ckeditor = window.CKEDITOR.replace(self.id, {
      height: this.height
    });

    // 设置初始内容
    self.ckeditor.setData(self.value);

    // 监听内容变更事件(相当于v-model)
    self.ckeditor.on("change", function() {
      self.$emit("input", self.ckeditor.getData());
    });
   
    window.CKEDITOR.on('doubleclick', (data) => {
      // console.log('!!!doubleclick', data);
      this.$emit('openDialog', data.data);
    })
  },
  data: function() {
    return {
      id: parseInt(Math.random() * 10000).toString(),
      ckeditor: null,
    };
  },
  methods: {
    insertHtml(value) {
      this.ckeditor.insertHtml(value);
    },
    setData(value) {
      this.ckeditor.setData(value);
    },
  },
  watch: {
    // 监听prop的变化，更新ckeditor中的值
    value: {
      handler() {
        if (this.value !== this.ckeditor.getData()) {
          this.ckeditor.setData(this.value);
        }
      }
    }
  },
  // 销毁组件前，销毁编辑器
  beforeDestroy: function() {
    this.ckeditor.destroy();
  },
};
</script>
